import React from 'react'
import { WebsocketActionTypes, WebsocketTypes } from './websocketReducer'

export const websocketMessage = (dispatch: React.Dispatch<WebsocketActionTypes>, message: string, key: string): void => {
  dispatch({
    type: WebsocketTypes.WEBSOCKET_MESSAGE,
    message,
    key
  })
}
